import * as betroyale from './TermsConditions.styles.betroyale';
import * as fiestabet from './TermsConditions.styles.fiestabet';
import * as goldenrush from './TermsConditions.styles.goldenrush';
import * as juicybet from './TermsConditions.styles.juicybet';
import * as puntcity from './TermsConditions.styles.puntcity';
import * as questbet from './TermsConditions.styles.questbet';
import * as vikingbet from './TermsConditions.styles.vikingbet';
import * as volcanobet from './TermsConditions.styles.volcanobet';
import { EThemesOG } from '@/constants/themeConfig';

export const styleImports: Partial<Record<EThemesOG, any>> = {
  betroyale,
  fiestabet,
  goldenrush,
  juicybet,
  puntcity,
  questbet,
  vikingbet,
  volcanobet,
};
